import { type IColumn, Icon, Typography } from 'shared/ui'
import { type RowQuietHours } from '../../model/RowQuietHours'
import styles from './styles.module.scss'

export const columns: IColumn<RowQuietHours>[] = [
  {
    field: 'days',
    name: 'Days',
    ariaLabel: 'Days',
    minWidth: 200,
    renderRowCell: (row) => {
      return (
        <Typography variant={'body-md-regular'} ariaLabel={'days'}>
          {row.days}
        </Typography>
      )
    },
  },
  {
    field: 'timeRange',
    name: 'Send or call at',
    ariaLabel: 'Send or call at',
    minWidth: 200,
    renderRowCell: (row) => {
      const isWeekend = row.id === 'weekend'
      const iconName = isWeekend ? 'slashCircle' : 'check1'
      const color = isWeekend ? 'var(--red-60)' : 'var(--green-70)'

      return (
        <div className={styles.timeRangeCell}>
          <Icon icon={iconName} className={styles.timeRangeIcon} color={color} />
          <Typography variant={'body-md-regular'} ariaLabel={'time range'}>
            {row.timeRange}
          </Typography>
        </div>
      )
    },
  },
]
